import getRegionRegulation from './regionRegulation';
import getCountryRegulation from './countyRegulation';

/**
 * Regulation factory class.
 *
 * @class
 * @returns {Array} Regulation.
 **/
class RegulationsFactory {

    static create(country) {
        const [countryCode, regionCode] = typeof country === 'string' ? [...country.split('-')] : ['', ''];
        let regulation = [];

        regionCode ? regulation = getRegionRegulation(countryCode, regionCode) : regulation = getCountryRegulation(countryCode);
        return regulation;
    }

}

export default RegulationsFactory;